import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useTheme } from "../../../contexts/ThemeContext";
import { useAuth } from "../../../contexts/AuthContext";
import LayoutDesktop from "../../../layouts/LayoutDesktop";
import LayoutMobile from "../../../layouts/LayoutMobile";
import { useIsMobile } from "../../../hooks/useIsMobile";

import { db } from "../../../config/firebase";
import {
  collection,
  doc,
  getDocs,
  query,
  where,
  runTransaction,
  setDoc,
  serverTimestamp,
} from "firebase/firestore";

// contador dentro do grupo: status_<grupoId>
async function obterProximoCodigoSequencialStatus(grupoId) {
  const contadorRef = doc(db, "contadores", `status_${grupoId}`);

  

  // ✅ garante que o contador exista com grupoId (evita PERMISSION_DENIED no transaction.get quando o doc ainda não existe)
  await setDoc(contadorRef, { grupoId }, { merge: true });
const proximo = await runTransaction(db, async (transaction) => {
    const snap = await transaction.get(contadorRef);

    let atual = 0;
    if (snap.exists() && snap.data().ultimoCodigoSequencial != null) {
      atual = snap.data().ultimoCodigoSequencial;
    }

    const novoValor = atual + 1;

    transaction.set(
      contadorRef,
      { ultimoCodigoSequencial: novoValor, grupoId },
      { merge: true }
    );

    return novoValor;
  });

  return proximo;
}

function NovoStatus() {
  const { tema } = useTheme();
  const { usuario: usuarioLogado } = useAuth();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const [empresas, setEmpresas] = useState([]);
  const [carregandoEmpresas, setCarregandoEmpresas] = useState(false);

  const [empresaId, setEmpresaId] = useState("");
  const [statusGlobal, setStatusGlobal] = useState(false);
  const [nome, setNome] = useState("");
  const [cor, setCor] = useState("#dc2626"); // vermelho padrão
  const [observacoes, setObservacoes] = useState("");

  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");
  const [salvando, setSalvando] = useState(false);
  const [sidebarAberta, setSidebarAberta] = useState(false);

  useEffect(() => {
    async function carregarEmpresas() {
      if (!usuarioLogado?.grupoId) return;

      setCarregandoEmpresas(true);
      setErro("");

      try {
        const empresasRef = collection(db, "empresas");
        const q = query(
          empresasRef,
          where("grupoId", "==", usuarioLogado.grupoId)
        );
        const snap = await getDocs(q);

        const lista = snap.docs.map((docSnap) => ({
          id: docSnap.id,
          ...docSnap.data(),
        }));

        setEmpresas(lista);

        // se tiver só 1 empresa, já pré-seleciona
        if (lista.length === 1) {
          setEmpresaId(lista[0].id);
        }
      } catch (e) {
        console.error("Erro ao carregar empresas:", e);
        setErro("Erro ao carregar empresas. Verifique o cadastro do grupo.");
      } finally {
        setCarregandoEmpresas(false);
      }
    }

    carregarEmpresas();
  }, [usuarioLogado]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro("");
    setSucesso("");

    if (!usuarioLogado?.grupoId) {
      setErro(
        "Usuário logado não possui grupo definido. Verifique o cadastro do Gestor."
      );
      return;
    }

    if (!nome.trim()) {
      setErro("Informe o nome do status.");
      return;
    }

    const grupoId = usuarioLogado.grupoId;
    const grupoNome = usuarioLogado.grupoNome || usuarioLogado.grupo || null;

    let empresaIdFinal = empresaId || null;
    let empresaNome = null;

    if (statusGlobal) {
      empresaIdFinal = null;
      empresaNome = "Global (todas as empresas)";
    } else {
      if (!empresaId) {
        setErro("Selecione a empresa.");
        return;
      }

      const empresaSelecionada = empresas.find((e) => e.id === empresaId);
      if (!empresaSelecionada) {
        setErro("Empresa selecionada inválida.");
        return;
      }
      empresaNome = empresaSelecionada.nome || "(sem nome)";
    }

    setSalvando(true);

    try {
      const sequencial = await obterProximoCodigoSequencialStatus(grupoId);
      const codigo = `ST${String(sequencial).padStart(4, "0")}`;

      const novaRef = doc(collection(db, "statusOs"));
      await setDoc(novaRef, {
        codigo,
        codigoSequencial: sequencial,

        nome: nome.trim(),
        cor: cor || "#000000",
        observacoes: observacoes.trim() || null,

        grupoId,
        grupoNome: grupoNome || null,
        empresaId: empresaIdFinal,
        empresaNome,

        padrao: false, // os padrões do sistema devem ser criados com padrao: true

        criadoPor: usuarioLogado?.uid || null,
        criadoEm: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });

      setSucesso(`Status criado com sucesso (código ${codigo}).`);
      setNome("");
      setCor("#dc2626");
      setObservacoes("");
      // mantém empresa selecionada
    } catch (err) {
      console.error(err);
      setErro("Erro ao salvar status. Tente novamente.");
    } finally {
      setSalvando(false);
    }
  };

  const Layout = isMobile ? LayoutMobile : LayoutDesktop;

  const inputStyle = {
    width: "100%",
    padding: "9px 11px",
    marginTop: 4,
    borderRadius: 8,
    border: "1px solid #334155",
    boxSizing: "border-box",
  };

  const conteudo = (
    <section style={{ width: "100%" }}>
      <div
        className={isMobile ? "m-card" : "pc-card"}
        style={{
          width: "100%",
          padding: isMobile ? 16 : "16px 40px",
          boxSizing: "border-box",
        }}
      >
        {!isMobile && (
          <header className="pc-table-header">
            <div className="pc-table-header-text">
              <h3>Cadastro de status de OS</h3>
              <p>
                Cadastre status para uso nas Ordens de Serviço, por empresa do
                grupo atual.
              </p>
            </div>
          </header>
        )}

        {erro && (
          <div
            style={{
              marginTop: isMobile ? 0 : 12,
              marginBottom: 12,
              padding: 8,
              borderRadius: 8,
              background: "#7f1d1d",
              color: "#fecaca",
              fontSize: 14,
            }}
          >
            {erro}
          </div>
        )}

        {sucesso && (
          <div
            style={{
              marginTop: isMobile ? 0 : 12,
              marginBottom: 12,
              padding: 8,
              borderRadius: 8,
              background: "#14532d",
              color: "#bbf7d0",
              fontSize: 14,
            }}
          >
            {sucesso}
          </div>
        )}

        <form
          onSubmit={handleSubmit}
          style={{
            marginTop: isMobile ? 0 : 12,
            maxWidth: isMobile ? "100%" : 720,
            marginLeft: "auto",
            marginRight: "auto",
            display: "flex",
            flexDirection: "column",
            gap: 12,
          }}
        >
          <label>
            <span style={{ fontSize: 14 }}>Nome *</span>
            <input
              type="text"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              required
              className={isMobile ? "m-input" : ""}
              style={inputStyle}
            />
          </label>

          <label>
            <span style={{ fontSize: 14 }}>Empresa</span>
            <select
              value={statusGlobal ? "global" : empresaId}
              onChange={(e) => {
                const val = e.target.value;
                if (val === "global") {
                  setStatusGlobal(true);
                  setEmpresaId("");
                } else {
                  setStatusGlobal(false);
                  setEmpresaId(val);
                }
              }}
              disabled={carregandoEmpresas}
              className={isMobile ? "m-select" : ""}
              style={{ ...inputStyle, color: "inherit" }}
            >
              <option value="">
                {carregandoEmpresas
                  ? "Carregando empresas..."
                  : "Selecione a empresa"}
              </option>
              <option value="global">Status Global (todas as empresas)</option>
              {empresas.map((emp) => (
                <option key={emp.id} value={emp.id}>
                  {emp.nome || "(sem nome)"}
                </option>
              ))}
            </select>
          </label>

          <label>
            <span style={{ fontSize: 14 }}>Cor</span>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 8,
                marginTop: 8,
              }}
            >
              {[
                { cor: "#2563eb", nome: "Azul" },
                { cor: "#0891b2", nome: "Ciano" },
                { cor: "#16a34a", nome: "Verde" },
                { cor: "#ca8a04", nome: "Amarelo" },
                { cor: "#d97706", nome: "Laranja" },
                { cor: "#dc2626", nome: "Vermelho" },
                { cor: "#7c3aed", nome: "Roxo" },
                { cor: "#db2777", nome: "Rosa" },
                { cor: "#64748b", nome: "Cinza" },
              ].map((opcao) => (
                <button
                  key={opcao.cor}
                  type="button"
                  onClick={() => setCor(opcao.cor)}
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 8,
                    backgroundColor: opcao.cor,
                    border: cor === opcao.cor ? "3px solid #fff" : "2px solid transparent",
                    outline: cor === opcao.cor ? `2px solid ${opcao.cor}` : "none",
                    cursor: "pointer",
                  }}
                  title={opcao.nome}
                />
              ))}
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                marginTop: 12,
              }}
            >
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 8,
                  backgroundColor: cor,
                  border: "1px solid #334155",
                  flexShrink: 0,
                }}
              />
              <span style={{ fontSize: 14, fontFamily: "monospace" }}>{cor}</span>
            </div>
          </label>

          <label>
            <span style={{ fontSize: 14 }}>Observações</span>
            <textarea
              value={observacoes}
              onChange={(e) => setObservacoes(e.target.value)}
              rows={3}
              className={isMobile ? "m-input" : ""}
              style={{
                ...inputStyle,
                resize: "vertical",
              }}
            />
          </label>

          <div
            className={isMobile ? "m-form-actions" : ""}
            style={isMobile ? {} : {
              marginTop: 16,
              display: "flex",
              justifyContent: "flex-end",
              gap: 8,
            }}
          >
            <button
              type="submit"
              className={isMobile ? "m-btn-primary" : "pc-btn-primario"}
              disabled={salvando || carregandoEmpresas}
            >
              {salvando ? "Salvando..." : "Salvar status"}
            </button>
            <button
              type="button"
              className={isMobile ? "m-btn-secondary" : "pc-btn-secundario"}
              onClick={() => navigate("/cadastros/status")}
            >
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </section>
  );

  return (
    <Layout 
      tema={tema} 
      titulo="Novo Status"
      sidebarAberta={sidebarAberta}
      onToggleSidebar={() => setSidebarAberta(!sidebarAberta)}
    >
      {conteudo}
    </Layout>
  );
}

export default NovoStatus;
